import { LogoutOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Menu, Row, Typography } from "antd";
import { logo, ROLE } from "../../constants/common";

export function SideBar({
  user,
  pathname,
  navList,
  categoryList,
  onNavCLick,
  onLogout,
}) {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ padding: "16px 32px" }}>
        <img src={logo} alt="logo" style={{ width: 80, height: "auto" }} />
      </div>

      <div style={{ padding: "16px 32px" }}>
        <Row align="middle" gutter={12}>
          <Col>
            <Avatar src={user?.avatar} style={{ width: 46, height: 46 }}>
              {user?.name[0]}
            </Avatar>
          </Col>
          <Col flex="auto">
            <Typography.Text strong>{user?.name}</Typography.Text>
            <br />
            <Typography.Text type="secondary">
              {ROLE[`${user?.role}`]}
            </Typography.Text>
          </Col>
        </Row>
      </div>

      <div style={{ marginBottom: 32, padding: "0 8px" }}>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[pathname]}
          items={navList}
          onClick={onNavCLick}
          style={{
            border: 0,
            backgroundColor: "transparent",
          }}
        />
      </div>

      <div style={{ flex: 1, padding: "0 8px" }}>
        <Menu
          theme="light"
          mode="inline"
          selectedKeys={[pathname]}
          items={categoryList}
          onClick={onNavCLick}
          style={{
            border: 0,
            backgroundColor: "transparent",
          }}
        />
      </div>

      <div style={{ padding: "0 8px", paddingBottom: "16px" }}>
        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={() => onLogout?.()}
          size="small"
          style={{
            width: "100%",
            justifyContent: "start",
            padding: "20px 32px",
          }}
        >
          Đăng xuất
        </Button>
      </div>
    </div>
  );
}
